/**
 * Renders stub VNode for component.
 */
export default {
  /**
   * @param {function} h
   * @returns {VNode}
   */
  render (h) {
    const options = this.$options.stubVNode || {}
    // render as HTML comment
    if (options.empty) {
      let vnode = h()
      if (typeof options.empty === 'string') {
        vnode.text = options.empty
      } else if (typeof options.empty === 'function') {
        vnode.text = h.call(options.empty())
      }

      return vnode
    }

    let children
    if (options.slots === false) {
      children = undefined
    } else {
      children = extractChildren(this.$slots, options.slots)
    }

    // console.log(options.attrs)
    let attrs = typeof options.attrs === 'function' ? h.call(options.attrs()) : options.attrs
    
    // console.log(attrs);
    let data = {
      attrs,
      style: {
        display: 'none !important',
      },
    }
    let renderer = h(options.tag || 'i', data, children)
    // console.log(renderer)
    // console.log("HERE")
    return renderer
  },
}

function extractChildren (slots, slotNames = []) {
  return Object.keys(slots).reduce((all, name) => {
    if (!slotNames.length || slotNames.includes(name)) {
      all = all.concat(slots[name])
    }

    return all
  }, [])
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/compilers/stub-vnode.js